import { useCopilotAction } from '@copilotkit/react-core';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { TOOL_NAMES } from '@/helpers/aiChat/tools';
import { PeoplePageRouterState } from '@/types/routerState';

export const useImportEmployeesCSVTool = () => {
  const navigate = useNavigate();

  useCopilotAction({
    name: TOOL_NAMES.IMPORT_EMPLOYEES_CSV,
    description:
      'Navigates to the Employees page and opens the CSV import modal so the user can import employees from a CSV file. Use this when the user wants to import or bulk-add employees via CSV.',
    parameters: [
      {
        name: 'confirmed',
        type: 'boolean',
        description: 'Set to true to confirm opening the import modal.',
        required: false,
      },
    ],
    handler: async () => {
      const state: PeoplePageRouterState = {
        modalData: {
          employeesWithoutDevices: [],
          showDeviceEnrollmentReminderModalFromRouterState: false,
          openImportCSVModal: true,
        },
      };
      navigate(ROUTES.EMPLOYEES, { state });
      return 'Navigated to the Employees page and opened the CSV import modal. The user can now upload a CSV file to import employees.';
    },
  });
};
